<button (click)="onTitleClick()" class="accordion-item__header">
  <span>{{ title }}</span>
  <span class="accordion-item__icon" [ngClass]="{ 'accordion-item__icon--expanded': expanded }">
    <mat-icon inline>expand_more</mat-icon>
  </span>
</button>
<div *ngIf="expanded" class="accordion-item__content">
  <ng-content></ng-content>
</div>
